"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerCluster = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function () {
  return (0, _core.createStyles)({
    //@ts-ignore
    root: _objectSpread(_objectSpread({
      textTransform: "none",
      maxHeight: function maxHeight(props) {
        return props.size === "small" ? 24 : 28;
      },
      minWidth: function minWidth(props) {
        return props.size === "small" ? 24 : 28;
      },
      borderRadius: "50%",
      margin: 0
    }, _Fonts.Fonts.Default.Caption), {}, {
      lineHeight: 1,
      border: "1px solid ".concat(_pittaModules.LightColors.primary["0"]),
      backgroundColor: function backgroundColor(props) {
        return props.color === "secondary" ? _pittaModules.LightColors.secondary["11"] : _pittaModules.LightColors.primary["7"];
      },
      color: _pittaModules.LightColors.primary["0"],
      filter: "drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.14))\n    drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.12)) \n    drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.2))"
    }),
    label: {
      padding: 0
    },
    outlined: {
      border: function border(props) {
        return props.variant === "outlined" ? "1px solid ".concat(_pittaModules.LightColors.primary["7"]) : "1px solid ".concat(_pittaModules.LightColors.primary["0"]);
      },
      backgroundColor: function backgroundColor(props) {
        return props.variant === "outlined" ? _pittaModules.LightColors.primary["0"] : _pittaModules.LightColors.primary["7"];
      },
      color: function color(props) {
        return props.variant === "outlined" ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["0"];
      },
      "&:hover": {
        backgroundColor: function backgroundColor(props) {
          return props.variant === "outlined" ? "".concat(_pittaModules.LightColors.primary["0"], "!important") : "".concat(_pittaModules.LightColors.primary["7"], "!important");
        }
      },
      "&:focus": {
        backgroundColor: function backgroundColor(props) {
          return props.variant === "outlined" ? "".concat(_pittaModules.LightColors.primary["0"], "!important") : "".concat(_pittaModules.LightColors.primary["7"], "!important");
        }
      }
    }
  });
});
var MarkerCluster = function MarkerCluster(props) {
  var classes = useStyle(props);
  var className = props.className,
    variant = props.variant,
    label = props.label,
    size = props.size,
    style = props.style,
    onClick = props.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Chip.default, {
    classes: classes,
    className: className,
    label: label,
    variant: variant || "outlined",
    size: size || "medium",
    style: style,
    onClick: onClick
  }));
};
exports.MarkerCluster = MarkerCluster;